module.exports = __webpack_public_path__ + "img/panagiotis.6f4e0284.jpeg";